import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Custom log function
import compressImage from "./compressImage.js";
import runWithConcurrency from "./runWithConcurrency.js";

// Upload photos function
const uploadPhoto = async (folderId, docId, token, photoId, prefix) => {
  try {
    // Create a promise that resolves when files are selected
    const selectFiles = () => {
      return new Promise((resolve, reject) => {
        const input = document.createElement("input");
        input.type = "file";
        input.multiple = true;
        input.accept = "image/*"; // Limit to images only

        input.onchange = () => {
          if (input.files && input.files.length > 0) {
            resolve(input.files);
          } else {
            reject(new Error("No files selected"));
          }
        };

        input.onerror = () => reject(new Error("Error selecting files"));

        // Trigger the file input dialog
        input.click();
      });
    };

    // Allow user to pick files
    const files = await selectFiles();

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("No authenticated user found.");
      return;
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      return;
    }

    const org_id = userSnapshot.get("org_id");

    // Upload a single file (parallelized below via runWithConcurrency).
    const uploadOne = async (file) => {
      // Compress/resize images before upload to avoid full-res phone photos.
      const fileToUpload = await compressImage(file);
      const url = `${prefix}folders/${folderId}/documents/${docId}/photo/${photoId}`;

      const formData = new FormData();
      formData.append("file", fileToUpload, fileToUpload.name);

      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let start = new Date();

      const response = await fetch(url, {
        method: "POST",
        headers,
        body: formData,
      });

      const responseText = await response.text();
      let end = new Date();
      let elapsed = end - start;
      // Log the upload action (fire-and-forget, do not block other uploads)
      addLogDocument(
        url,
        prefix,
        userRef,
        org_id,
        response.status.toString(),
        folderId,
        "", // Assuming empty for docId
        "", // Request body as string
        responseText,
        "POST",
        elapsed
      ).catch((e) => console.error("Error logging document:", e));

      // Check response status
      if (response.ok) {
      } else {
        console.error(`Error uploading file: ${response.status}`);
      }
    };

    // Run uploads in parallel with a max of 4 in flight.
    await runWithConcurrency(Array.from(files), uploadOne, 4);
  } catch (error) {
    console.error("Error selecting or uploading files:", error);
  }
};

export default uploadPhoto;
